import { Component } from "react";
import Footer from "../../common/Footer.js";
import AdminSideNav from "../../common/AdminSideNav.js";
import TopNav from "../../common/TopNav.js";
import {
  Button,
  Modal,
  Form,
  Table,
  Dropdown,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import Select from "react-select";
import { connect } from "react-redux";
import requireAuth from "../../hoc/requireAuth";
import authorizeAdmin from "../../hoc/authorizeAdmin";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/js/src/collapse.js";
import "sweetalert2/src/sweetalert2.scss";
import Loader from "react-loader-spinner";
import { withAlert } from "react-alert";
import "./../../itemsAlignment.css";
import PaginationComponentV1 from "../../common/PaginationComponentV1";
const FormData = require("form-data");

class EnforcementConfiguration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mailBody: [],
      availableCompanies: [],
      filteredCategory: [],
      companyFilter: null,
      categoryFilter: null,
      statusFilter: null,
      filteredCompany: [],
      selectedBrand: null,
      status: true,
      showModal: false,
      showAddPlatformModal: false,
      authorised: true,
      brands: [],
      errorMessage: null,
      brandName: "",
      searchTerm: "",
      category: "",
      selectedCompany: null,
      companies: [],
      EnforcementConfig: [],
      platform: {},
      pagination: {
        totalDocs: null,
        totalPages: null,
        page: 1,
        pagingCounter: 1,
        hasPrevPage: false,
        hasNextPage: true,
        prevPage: null,
        nextPage: 1,
      },
      perPage: 20,
      sortBy: "_id",
      sortDirection: -1,
      isLoading: false,
      hasMoreDomainData: true,
      search: "",
      selectedPlatform: "",
      selectedStartDate: "",
      selectedEndDate: "",
      selectedReportingPeriod: "",
      availablePlatforms: null,
      EnforcementConfigId: null,
      isUpdate: 1,
      attachments: [],
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleOpenAddPlatformModal =
      this.handleOpenAddPlatformModal.bind(this);
    this.handleCloseAddPlatformModal =
      this.handleCloseAddPlatformModal.bind(this);
    this.saveEnforcementConfiguration =
      this.saveEnforcementConfiguration.bind(this);
    this.listAllEnforcementConfigRecords =
      this.listAllEnforcementConfigRecords.bind(this);
    this.handleLimit = this.handleLimit.bind(this);
    this.sortTable = this.sortTable.bind(this);
    this.inputSearchBox = this.inputSearchBox.bind(this);
    this.handleSearchButton = this.handleSearchButton.bind(this);
    this.myPageChange = this.myPageChange.bind(this);
  }

  myPageChange(newPage) {
    this.setState({
      pagination: {
        ...this.state.pagination,
        page: newPage,
      },
    });
  }

  renderSaveOrUpdateButton() {
    if (this.state.EnforcementConfigId) {
      return (
        <Button
          onClick={() => this.saveEnforcementConfiguration(false)}
          variant="primary"
        >
          Update
        </Button>
      );
    } else {
      return (
        <Button
          onClick={() => this.saveEnforcementConfiguration(true)}
          variant="primary"
        >
          Save
        </Button>
      );
    }
  }

  handleSearchButton() {
    this.listAllEnforcementConfigRecords(true);
  }

  inputSearchBox(search) {
    this.setState({ search });
  }

  sortTable = (column) => {
    let { sortBy, sortDirection } = this.state;

    if (sortBy === column) {
      sortDirection = sortDirection === 1 ? -1 : 1;
    } else {
      sortBy = column;
      sortDirection = 1;
    }

    // Update state
    this.setState({ sortBy, sortDirection });
  };

  handleLimit(e) {
    this.setState({ perPage: e });
    this.setState((prevState) => ({
      pagination: {
        ...prevState.pagination,
        page: 1,
      },
    }));
  }

  renderLoader() {
    if (this.state.isLoading) {
      return (
        <div className="text-center">
          <Loader
            type="ThreeDots"
            color="#00BFFF"
            height={10}
            width={200}
            timeout={5000} //3 secs
          />
        </div>
      );
    }
  }

  async saveEnforcementConfiguration(update) {
    // Validation
    if (!this.state.selectedCompany?.value) {
      this.props.alert.show("Please select a company.", { type: "error" });
      return;
    }

    if (!this.state.selectedBrand?.value) {
      this.props.alert.show("Please select a brand.", { type: "error" });
      return;
    }

    if (
      !this.state.platform ||
      (typeof this.state.platform === "object" && !this.state.platform.value)
    ) {
      this.props.alert.show("Please select a platform.", { type: "error" });
      return;
    }

    const mailBody = this.state.mailBody;

    // Check: is array AND contains at least one non-empty string
    const isValidMailBody =
      Array.isArray(mailBody) &&
      mailBody.some((item) => typeof item === "string" && item.trim() !== "");

    if (!isValidMailBody) {
      this.props.alert.show("Mail body cannot be empty.", { type: "error" });
      return;
    }

    let reqParam = {
      company: this.state.selectedCompany?.value,
      brand: this.state.selectedBrand?.value,
      platform: this.state.platform,
      status: this.state.status,
      attachments: this.state.attachments,
      mailBody: this.state.mailBody,
    };

    let endPoint = "/enforcement-mail-configuration";
    if (this.state.EnforcementConfigId) {
      reqParam.EnforcementConfigId = this.state.EnforcementConfigId;
      endPoint = `/enforcement-mail-configuration/edit`;
    }

    await window.axios
      .post(`${endPoint}`, reqParam)
      .then((response) => {
        this.props.alert.show(response.data.message);
        this.handleCloseModal();
        this.listAllEnforcementConfigRecords(update);
      })
      .catch((error) => {
        let statusCode = error.response.status;
        let errors = error.response.data.errors;
        let errorMessage = error.response.data.message;

        if (statusCode === 401 || statusCode === 400 || statusCode === 500) {
          this.props.alert.show(`Oops ${errorMessage}`, { type: "error" });
          return;
        }

        if (statusCode === 422) {
          let errorMessageObj = {};

          for (let errorData of errors) {
            let errorKeyName = Object.keys(errorData)[0];
            errorMessageObj[errorKeyName] = errorData[errorKeyName];
          }

          this.setState(() => {
            return { errorMessage: errorMessageObj };
          });

          this.props.alert.show(`Oops ${errorMessage}`, { type: "error" });

          return;
        }

        this.props.alert.show(error.response.data.message, { type: "error" });
      });
  }

  handleOpenModal() {
    this.setState((prevState) => {
      return {
        showModal: true,
      };
    });
    this.listAllCompanies();
  }

  async handleCloseAddPlatformModal() {
    this.setState(() => ({ showAddPlatformModal: false }));
  }

  async handleOpenAddPlatformModal() {
    this.setState(() => ({ showAddPlatformModal: true }));
  }

  async removeEnforcementConfig(EnforcementConfig) {
    await window.axios
      .delete(`/enforcement-mail-configuration/${EnforcementConfig?._id}`)
      .then((response) => {
        this.listAllEnforcementConfigRecords(true);
        this.props.alert.show(response.data.message);
      })
      .catch((error) => {
        this.props.alert.show(error.response.data, { type: "error" });
      });
  }

  async showEditPopup(EnforcementConfig) {
    await this.setState((prevState) => {
      return {
        EnforcementConfigId: EnforcementConfig._id,
        status: EnforcementConfig.status ? true : false,
        showModal: true,
        platform: EnforcementConfig.platform ? EnforcementConfig.platform : {},
        selectedBrand: EnforcementConfig.brand
          ? {
              label: EnforcementConfig.brand.brandName,
              value: EnforcementConfig.brand._id,
            }
          : null,
        selectedCompany: EnforcementConfig.company
          ? {
              label: EnforcementConfig.company.name,
              value: EnforcementConfig.company._id,
            }
          : null,
        mailBody:
          typeof EnforcementConfig.mailBody === "string"
            ? EnforcementConfig.mailBody.split("\n")
            : EnforcementConfig.mailBody || [],
        attachments: EnforcementConfig.attachments
          ? EnforcementConfig.attachments
          : [],
        isUpdate: 0,
      };
    });
  }

  handleCloseModal() {
    this.setState((prevState) => {
      return {
        selectedBrand: null,
        selectedCompany: null,
        showModal: false,
        platform: {},
        status: false,
        mailBody: [],
        attachments: [],
        EnforcementConfigId: null,
        isUpdate: 0,
      };
    });
  }

  async listAllEnforcementConfigRecords(reArrangeRecords = false) {
    let reqData = {
      page: this.state.pagination.page,
      perPage: this.state.perPage,
    };

    reqData.sortBy = this.state.sortBy;
    reqData.sortDirection = this.state.sortDirection;
    if (reArrangeRecords) {
      reqData.page = 1;
    }
    reqData.search = this.state.search;

    this.setState(() => ({ isLoading: true }));

    await window.axios
      .get("/enforcement-mail-configuration", {
        params: reqData,
      })
      .then((res) => {
        this.setState(() => ({
          EnforcementConfig: res.data.results,
          isLoading: false,
          pagination: {
            page: res.data.pagination.page,
            nextPage: res.data.pagination.nextPage,
            prevPage: res.data.pagination.prevPage,
            hasNextPage: res.data.pagination.hasNextPage,
            hasPrevPage: res.data.pagination.hasPrevPage,
            pagingCounter: res.data.pagination.pagingCounter,
            totalDocs: res.data.pagination.totalDocs,
            totalPages: res.data.pagination.totalPages,
          },
          hasMoreDomainData: res.data.pagination.hasNextPage,
        }));
      });
  }

  async changeInputBox(e, column) {
    let state = {};
    state[column] = e.target.value;
    await this.setState(() => {
      return state;
    });
  }

  componentDidMount() {
    this.listAllEnforcementConfigRecords();
  }

  async getBrands() {
    await window.axios
      .get("/brand", {
        params: {
          disabledBrands: true,
          company: this.state.selectedCompany.value,
          page: 1,
          perPage: 800,
        },
      })
      .then((res) => {
        this.setState({
          brands: res.data.docs,
          isUpdate: 0,
        });
      });
  }

  componentDidUpdate(prevProps, prevState) {
    // This runs when the component updates
    // You can check if specific state or props changed and perform side effects accordingly
    if (
      this.state.pagination.page !== prevState.pagination.page ||
      this.state.perPage !== prevState.perPage ||
      this.state.sortBy !== prevState.sortBy ||
      this.state.sortDirection !== prevState.sortDirection
    ) {
      this.listAllEnforcementConfigRecords();
    }

    if (
      prevState.selectedCompany !== this.state.selectedCompany &&
      this.state.isUpdate
    ) {
      this.getBrands();
    }

    if (
      this.state.selectedBrand &&
      this.state.selectedBrand !== prevState.selectedBrand // Check if the brand has changed
    ) {
      let selectedBrand = this.state.brands.filter(
        (brand) => brand.id === this.state.selectedBrand.value
      );

      if (selectedBrand.length) {
        let platform = selectedBrand[0].platform;

        this.setState(() => ({
          availablePlatforms: platform,
        }));
      } else {
        this.setState(() => ({
          availablePlatforms: null,
        }));
      }
    }
  }

  async getCompanies() {
    await window.axios
      .get("/company", {
        params: {
          perPage: 100,
        },
      })
      .then((res) => {
        this.setState({
          availableCompanies: res.data.docs,
        });
      });
  }

  async listAllCompanies() {
    await window.axios
      .get("/company", {
        params: {
          perPage: 100,
        },
      })
      .then((res) => {
        let companies = [];

        res?.data?.docs.map((company) =>
          companies.push({
            label: company.name,
            value: company._id,
          })
        );

        this.setState({ companies: companies });
      });
  }

  showCompanySelectBox() {
    return (
      <div className="col-6">
        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Company *</Form.Label>
          <Select
            name="company"
            value={this.state.selectedCompany}
            onChange={(e) => this.changeCompany(e)}
            options={this.state.companies}
            isDisabled={this.state.EnforcementConfigId}
          />
          <span className="form-text-error-text">
            {this.state.errorMessage?.company}
          </span>
        </Form.Group>
      </div>
    );
  }

  showBrandSelectBox() {
    return (
      <div className="col-6">
        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Brand</Form.Label>
          <Select
            name="company"
            value={this.state.selectedBrand}
            onChange={(e) => this.changeBrand(e)}
            options={this.state.brands.map((brand, brandKey) => ({
              value: brand.id,
              label: brand.brandName,
            }))}
            isDisabled={this.state.EnforcementConfigId}
          />
          <span className="form-text-error-text">
            {this.state.errorMessage?.brand}
          </span>
        </Form.Group>
      </div>
    );
  }

  async changeCompany(e) {
    await this.setState(() => {
      return {
        selectedCompany: e,
        isUpdate: 1,
      };
    });
  }

  handlePdfUpload = async (event) => {
    const files = event.target.files;
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      if (files[i].type === "application/pdf") {
        formData.append("files", files[i]);
      } else {
        alert("Only PDF files are allowed.");
        return;
      }
    }

    try {
      const res = await window.axios.post(
        "/upload-images-to-s3/enforcement-configuration",
        formData
      );

      const awsResponseArray = res.data.Data;

      const attachments = awsResponseArray.map((item, index) => ({
        fileName: files[index].name,
        url: item.Location,
      }));

      this.setState((prevState) => ({
        attachments: [...prevState.attachments, ...attachments],
      }));
    } catch (error) {
      this.setState({ dataSaveError: { data: "Error uploading file." } });
      setTimeout(() => {
        this.setState({ dataSaveError: null });
      }, 3000);
      console.error("Error uploading file:", error);
    }
  };

  async changeBrand(e) {
    await this.setState(() => {
      return {
        selectedBrand: e,
      };
    });
  }

  async changePlatform(e) {
    await this.setState(() => ({ selectedPlatform: e }));
  }

  handleStatusChange = async (e) => {
    await this.setState(() => ({
      status: e.target.checked,
    }));
  };

  renderEnforcementConfiguration() {
    return this.state.EnforcementConfig.map(
      (EnforcementConfig, EnforcementConfigKey) => (
        <>
          <tr
            key={EnforcementConfigKey}
            data-toggle="collapse"
            data-target={".multi-collapse" + EnforcementConfigKey}
            aria-controls={"multiCollapseExample" + EnforcementConfigKey}
          >
            <td>
              <p className="mx-0 my-0">
                {this.state.pagination.pagingCounter + EnforcementConfigKey}
              </p>
            </td>
            <td>
              <p className="mx-0 my-0">{EnforcementConfig.company.name}</p>
            </td>
            <td>
              <p className="mx-0 my-0">{EnforcementConfig.brand.brandName}</p>
            </td>
            <td>
              <p className="mx-0 my-0">{EnforcementConfig.platform}</p>
            </td>
            <td>
              <span
                className={
                  EnforcementConfig.status ? "text-success" : "text-danger"
                }
              >
                {EnforcementConfig.status ? "Enabled" : "Disabled"}
              </span>
            </td>
            <td>
              <a
                className="text-danger"
                onClick={(e) => this.removeEnforcementConfig(EnforcementConfig)}
                href="#"
              >
                <i className="fa fa-trash"></i>
              </a>
              <a
                className="text-primary mx-1"
                onClick={(e) => this.showEditPopup(EnforcementConfig)}
                href="#"
              >
                <i className="fa fa-edit"></i>
              </a>
            </td>
          </tr>
        </>
      )
    );
  }

  async handleCompanyFilterChange(e) {
    await this.setState(() => ({
      filteredCompany: e.target.value,
    }));
  }

  async handleCategoryFilterChange(e) {
    await this.setState(() => ({
      categoryFilter: e.target.value,
    }));
  }

  async handleStatusFilterChange(e) {
    await this.setState(() => ({
      statusFilter: e.target.value,
    }));
  }

  changePlatformSelectBox(e) {
    let selectedKeyValue = "domainKeys";

    let key = e.target.value;

    if (key === "website") {
      selectedKeyValue = "websiteKeys";
    }
    if (key === "social-media") {
      selectedKeyValue = "socialMediaKeys";
    }
    if (key === "e-commerce") {
      selectedKeyValue = "ecommerceKeys";
    }
    if (key === "app-store") {
      selectedKeyValue = "appStoreKeys";
    }

    this.setState({
      platform: e.target.value,
      excelData: [],
      selectedKey: selectedKeyValue,
    });
  }

  handleDeleteFile = (indexToDelete) => {
    this.setState((prevState) => {
      const updatedFiles = [...prevState.attachments];
      updatedFiles.splice(indexToDelete, 1);
      return { attachments: updatedFiles };
    });
  };

  renderHtml() {
    return (
      <div className="row">
        <AdminSideNav />

        <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
          <TopNav />

          <div className="main-content-container container-fluid px-4">
            <div className="d-flex align-items-center sticky-div-brand justify-content-between mb-2 mt-2">
              <div className="d-flex gap-4 align-items-center">
                <InputGroup className="">
                  <FormControl
                    placeholder=""
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={this.state.search}
                    onChange={(e) => {
                      this.inputSearchBox(e.target.value);
                    }}
                    style={{ width: "200px" }}
                  />
                </InputGroup>
                <Button onClick={this.handleOpenModal}>
                  Add Enforcement Configuration
                </Button>
              </div>

              <div className="d-flex justify-content-center align-items-center mt-3">
                <PaginationComponentV1
                  totalRecords={this.state.pagination.totalDocs}
                  itemsPerPage={this.state.perPage}
                  currentPage={this.state.pagination.page}
                  onPageChange={this.myPageChange}
                  displayPagesCount={8}
                />
              </div>
              <div className="d-flex justify-content-center align-items-center mt-2">
                <Dropdown style={{ width: "80px" }} onSelect={this.handleLimit}>
                  <Dropdown.Toggle variant="danger" id="limit">
                    {this.state.perPage}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      eventKey="10"
                      active={this.state.perPage == 10}
                    >
                      10
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="20"
                      active={this.state.perPage == 20}
                    >
                      20
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="50"
                      active={this.state.perPage == 50}
                    >
                      50
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="100"
                      active={this.state.perPage == 100}
                    >
                      100
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <span>{this.state.pagination.totalDocs} records</span>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="card card-small mb-4">
                  <div className="card-body p-0">
                    <Table width="100%" id="brand-table" className="table mb-0">
                      <thead className="bg-light uppercase-th">
                        <tr key="row_header">
                          <th
                            width="3%"
                            scope="col"
                            className="border-0"
                            onClick={() => this.sortTable("_id")}
                          >
                            Sr.{" "}
                            {this.state.sortBy === "_id"
                              ? this.state.sortDirection === 1
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            width="3%"
                            scope="col"
                            className="border-0"
                            onClick={() => this.sortTable("company.name")}
                          >
                            Company{" "}
                            {this.state.sortBy === "_id"
                              ? this.state.sortDirection === 1
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            width="3%"
                            scope="col"
                            className="border-0"
                            onClick={() => this.sortTable("brand.brandname")}
                          >
                            Brand{" "}
                            {this.state.sortBy === "_id"
                              ? this.state.sortDirection === 1
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            width="10%"
                            scope="col"
                            className="border-0"
                            onClick={() => this.sortTable("platform")}
                          >
                            Platform{" "}
                            {this.state.sortBy === "searchTerm"
                              ? this.state.sortDirection === 1
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            width="10%"
                            scope="col"
                            className="border-0"
                            onClick={() => this.sortTable("status")}
                          >
                            Status{" "}
                            {this.state.sortBy === "status"
                              ? this.state.sortDirection === 1
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th width="10%" scope="col" className="border-0">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>{this.renderEnforcementConfiguration()}</tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </main>
      </div>
    );
  }

  render() {
    return (
      <>
        {this.renderHtml()}
        {/* add new platform modal start */}
        <Modal
          size="xl"
          show={this.state.showModal}
          onHide={this.handleCloseModal}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "#d32f2f" }}>
              Enforcement Configuration Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="row">
                {this.showCompanySelectBox()}
                {this.showBrandSelectBox()}
                <div className="col-6">
                  <div className="form-group">
                    <span className="text-muted d-block mb-2">Platform *</span>
                    <select
                      value={this.state.platform}
                      onChange={(e) => this.changePlatformSelectBox(e)}
                      className="form-control"
                      disabled={this.state.EnforcementConfigId}
                    >
                      <option value="">Select from dropdown</option>
                      {((this.state.availablePlatforms &&
                        this.state.availablePlatforms.domain) ||
                        !this.state.availablePlatforms) && (
                        <option value="domain">Domain</option>
                      )}
                      {((this.state.availablePlatforms &&
                        this.state.availablePlatforms.website) ||
                        !this.state.availablePlatforms) && (
                        <option value="website">
                          Website
                        </option>
                      )}
                      {((this.state.availablePlatforms &&
                        this.state.availablePlatforms.socialMedia) ||
                        !this.state.availablePlatforms) && (
                        <option value="social-media">Social Media</option>
                      )}
                      {((this.state.availablePlatforms &&
                        this.state.availablePlatforms.eCommerce) ||
                        !this.state.availablePlatforms) && (
                        <option value="e-commerce">E-commerce</option>
                      )}
                      {((this.state.availablePlatforms &&
                        this.state.availablePlatforms.appStore) ||
                        !this.state.availablePlatforms) && (
                        <option value="app-store">
                          App Store
                        </option>
                      )}
                    </select>
                    {this.state.dataSaveError?.platform && (
                      <span className="text-danger">
                        {this.state.dataSaveError?.platform}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-check form-switch">
                    <input
                      style={{
                        pointerEvents: "auto",
                        cursor: "",
                        marginTop: "40px",
                      }}
                      onClick={(e) => this.handleStatusChange(e)}
                      checked={this.state.status ? true : false}
                      className="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckDefault"
                    />
                    <label
                      style={{ marginTop: "38px" }}
                      className="form-check-label"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      Status
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <span className="text-muted d-block mb-2">
                      Upload Attachments
                    </span>
                    <input
                      id="input"
                      name="files"
                      multiple
                      type="file"
                      accept="application/pdf"
                      onChange={this.handlePdfUpload}
                    />

                    <ul
                      className="d-flex flex-wrap p-0 m-0"
                      style={{ gap: "8px" }}
                    >
                      {this.state.attachments.map((file, index) => (
                        <li
                          key={index}
                          className="d-flex align-items-center bg-light rounded px-2 py-1"
                          style={{ maxWidth: "250px", wordBreak: "break-word" }}
                        >
                          <a
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="me-2 text-decoration-none text-primary"
                            style={{ flex: 1, overflowWrap: "break-word" }}
                          >
                            📎 {file.fileName}
                          </a>
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => this.handleDeleteFile(index)}
                          >
                            ❌
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                  {this.state.dataSaveError?.data && (
                    <span className="text-danger">
                      {this.state.dataSaveError?.data}
                    </span>
                  )}
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <span className="text-muted d-block mb-2">
                        Mail Content
                      </span>
                      <textarea
                        value={this.state.mailBody.join("\n")}
                        placeholder="Upload a file in .txt format"
                        rows="10"
                        cols="80"
                        disabled={false}
                        onChange={(e) => {
                          this.setState({
                            mailBody: e.target.value.split("\n"),
                          });
                        }}
                      />
                    </div>
                    {this.state.dataSaveError?.reportingDate && (
                      <span className="text-danger">
                        {this.state.dataSaveError?.reportingDate}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseModal}>
              Close
            </Button>
            {this.renderSaveOrUpdateButton()}
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  login: state.login,
  response: state.response,
});

export default withAlert()(
  connect(mapStateToProps)(
    authorizeAdmin(requireAuth(EnforcementConfiguration))
  )
);
